module.exports = __webpack_public_path__ + "img/login.f9bc9688.png";